import React, { useRef, useState } from "react";
import { FaCamera } from "react-icons/fa";
import img1 from "../assets/img/user/user1.png";
import img2 from "../assets/img/logo/profiel-logo.png";
import FileUploader from "../components/fileUploader/FileUploader";
import InputField from "../components/inputField/InputField";
import CustomSelector from "../components/selector/CustomSelector";

const Profile = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    dateOfBirth: "",
    email: "",
    homeAddress: "",
    city: "",
    state: "",
    zipCode: "",
    ssn: "",
    driverLicense: "",
    businessName: "",
    businessPhoneNumber: "",
    entityType: "",
    businessEmail: "",
    businessCity: "",
    businessZip: "",
    taxId: "",
    website: "",
    instagram: "",
    twitter: "",
    youtube: "",
    tiktok: "",
    other: "",
  });

  const [setProfileImage] = useState(null);
  const fileInputRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(URL.createObjectURL(file)); // Display the uploaded image
    }
  };

  const handleProfileUploadClick = () => {
    fileInputRef.current.click(); // Programmatically click the hidden file input
  };

  const handleBProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(URL.createObjectURL(file)); // Display the uploaded image
    }
  };

  const handleBProfileUploadClick = () => {
    fileInputRef.current.click(); // Programmatically click the hidden file input
  };

  return (
    <section className="profile_page page_overflow">
      <div className="container">
        {/* Professional Profile Section */}
        <div className="profile-section">
          <div className="upload-container">
            <img
              src={img1 || "https://via.placeholder.com/100"}
              alt="Upload Profile"
              style={{ width: 100, height: 100, objectFit: "cover" }}
            />
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept="image/*"
              onChange={handleProfileImageChange}
            />
            <button className="btn mt-3 p-3" onClick={handleProfileUploadClick}>
              <FaCamera className="icons" />
            </button>
          </div>

          <div className="input-group">
            <InputField
              label="Full Name"
              star="*"
              value={formData.fullName}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter full name"
              name="fullName"
            />
            <InputField
              label="Phone Number"
              star="*"
              value={formData.phoneNumber}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter phone number"
              name="phoneNumber"
            />
            <InputField
              label="Date of Birth"
              star="*"
              value={formData.dateOfBirth}
              onChange={handleInputChange}
              type="date"
              placeholder="Enter date of birth"
              name="dateOfBirth"
            />
            <InputField
              label="Email"
              star="*"
              value={formData.email}
              onChange={handleInputChange}
              type="email"
              placeholder="Enter email address"
              name="email"
            />
            <InputField
              label="Home Address"
              star="*"
              value={formData.homeAddress}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter home address"
              name="homeAddress"
            />
            <InputField
              label="City"
              star="*"
              value={formData.city}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter city"
              name="city"
            />
            <InputField
              label="State"
              star="*"
              value={formData.state}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter state"
              name="state"
            />
            <InputField
              label="Zip Code"
              star="*"
              value={formData.zipCode}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter zip code"
              name="zipCode"
            />
            <InputField
              label="Social Security #"
              star="*"
              value={formData.ssn}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter SSN"
              name="ssn"
            />
            <InputField
              label="Driver License #"
              star="*"
              value={formData.driverLicense}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter driver license"
              name="driverLicense"
            />
            <div className="file-upload">
              <FileUploader label="Upload Front of SSN" />
            </div>
            <div className="file-upload">
              <FileUploader label="Upload Front of ID" />
            </div>
            <div className="file-upload">
              <FileUploader label="Upload Back of SSN" />
            </div>
            <div className="file-upload">
              <FileUploader label="Upload Back of ID" />
            </div>
          </div>
        </div>
        <hr className="my-5" />
        {/* Business Information Section */}
        <div className="profile-section">
          <div className="upload-container">
            <img
              src={img2 || "https://via.placeholder.com/100"}
              alt="Upload Profile"
              style={{ width: 100, height: 100, objectFit: "cover" }}
            />
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept="image/*"
              onChange={handleBProfileImageChange}
            />
            <button
              className="btn mt-3 p-3"
              onClick={handleBProfileUploadClick}
            >
              <FaCamera className="icons" />
            </button>
          </div>
          <div className="input-group">
            <InputField
              label="Business Name"
              star="*"
              value={formData.businessName}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter business name"
              name="businessName"
            />
            <InputField
              label="Business Phone Number"
              star="*"
              value={formData.businessPhoneNumber}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter business phone number"
              name="businessPhoneNumber"
            />
            <div>
              <label htmlFor="Entity Type">Entity Type</label>
              <CustomSelector
                selectedText="select"
                options={[
                  { label: "Sole Proprietorship", value: "sole" },
                  { label: "Partnership", value: "partnership" },
                  { label: "LLC", value: "llc" },
                  { label: "S/C Corporation", value: "corporation" },
                ]}
                onSelect={(option) =>
                  setFormData({ ...formData, entityType: option.value })
                }
              />
            </div>
            <InputField
              label="Business Email"
              star="*"
              value={formData.businessEmail}
              onChange={handleInputChange}
              type="email"
              placeholder="Enter business email"
              name="businessEmail"
            />
            <InputField
              label="City"
              star="*"
              value={formData.businessCity}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter city"
              name="businessCity"
            />
            <InputField
              label="Zip Code"
              star="*"
              value={formData.businessZip}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter zip code"
              name="businessZip"
            />
            <InputField
              label="Tax ID or EIN #"
              star="*"
              value={formData.taxId}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter tax ID or EIN"
              name="taxId"
            />
            <InputField
              label="Website"
              value={formData.website}
              onChange={handleInputChange}
              type="url"
              placeholder="Enter website"
              name="website"
            />
            <InputField
              label="Instagram"
              value={formData.instagram}
              onChange={handleInputChange}
              type="url"
              placeholder="Enter Instagram handle"
              name="instagram"
            />
            <InputField
              label="YouTube"
              value={formData.youtube}
              onChange={handleInputChange}
              type="url"
              placeholder="Enter YouTube channel"
              name="youtube"
            />
            <InputField
              label="Twitter"
              value={formData.twitter}
              onChange={handleInputChange}
              type="url"
              placeholder="Enter Twitter handle"
              name="twitter"
            />
            <InputField
              label="TikTok"
              value={formData.tiktok}
              onChange={handleInputChange}
              type="url"
              placeholder="Enter TikTok handle"
              name="tiktok"
            />
            <InputField
              label="Other"
              value={formData.other}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter other information"
              name="other"
            />
            <div className="file-upload">
              <FileUploader label="Upload Articles of Organization" />
            </div>
            <div>
              {/* Submit Section */}
              <div className="terms-section">
                <label>
                  <input type="checkbox" /> Terms & Services
                </label>
                <label>
                  <input type="checkbox" /> Privacy Policy
                </label>
                <label>
                  <input type="checkbox" /> Consent to Background Check
                </label>
                <label>
                  <input type="checkbox" /> Data Protection & Security Policy
                </label>
                <label>
                  <input type="checkbox" /> Waiver of Responsibility & Legal
                  Liability Disclaimer
                </label>
              </div>
              <button className="btn">Submit for Approval</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;
